import axios from "axios";

export async function fetchRtoData(payload) {
  try {   
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    let apiUrl = `${baseUrl}/cloud/azure/capture-failover-rto`;
    const response = await axios.get(apiUrl, {
      params: payload,
    });
    return response?.data?.data;
  } catch (error) {
    console.error("Failed to fetch RTO data:", error);
    throw error;
  }
}
